var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9105 15.9863C18.8205 15.8963 18.7205 15.8063 18.6305 15.7163C16.1805 13.2563 13.7205 10.8063 11.2705 8.34627C10.9105 7.98627 10.9305 7.46627 11.3005 7.16627C11.5805 6.93627 12.0105 6.94627 12.2705 7.18627C12.4705 7.36627 12.6605 7.56627 12.8505 7.75627C14.9205 9.82627 17.0005 11.9063 19.0705 13.9763C19.4905 14.3963 19.9105 14.8163 20.3305 15.2463C20.7505 15.6663 20.7505 16.3063 20.3305 16.7263C19.7205 17.3363 19.1105 17.9463 18.5005 18.5563C17.0605 19.9963 15.6205 21.4463 14.1705 22.8863C13.5505 23.5063 12.9305 24.1263 12.3105 24.7363C12.0905 24.9563 11.7505 25.0163 11.4705 24.8963C11.1805 24.7663 10.9905 24.4863 11.0005 24.1663C11.0005 23.9563 11.0905 23.7763 11.2405 23.6363C12.4505 22.4263 13.6605 21.2263 14.8705 20.0163C15.3205 19.5663 15.7805 19.1163 16.2305 18.6563C17.1005 17.7863 17.9705 16.9163 18.8405 16.0463C18.8605 16.0263 18.8805 16.0063 18.9105 15.9763L18.9105 15.9863Z",
    fill: "#D3607D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/Arrow_Right.101f0213b981139a8e48f9a3ad34a47b.svg";
export { ForwardRef as ReactComponent };